(() => {
  if (!document.body.classList.contains("share-graphic")) return;

  // if the <body> is taller than 630px, look for .entry-content and reduce its
  // CSS custom property `--__max-lines` by 1 until the height is less than 630px or
  // until it reaches 1 line

  const entryContent = document.querySelector(".entry-content") as HTMLElement | null;
  if (!entryContent) return;

  const maxHeight = 630;
  let maxLines =
    parseInt(getComputedStyle(entryContent).getPropertyValue("--__max-lines")) || 5;
  let entryContentHeight = entryContent.scrollHeight;

  while (entryContentHeight > maxHeight && maxLines > 1) {
    maxLines -= 1;
    entryContent.style.setProperty("--__max-lines", maxLines.toString());
    entryContentHeight = entryContent.scrollHeight;
  }
})();
